export const NO_POSITION_MESSAGE = 'This catch does not have an exact position';
export const PRIVATE_MESSAGE = 'This catch is logged as private';
export const OWNED_PRIVATE_MESSAGE =
  'Private: only you can see exact catch location and water name';
export const OWNED_COMPETITIVE_MESSAGE = 'Secret spot: only you can see exact catch location';
